/* Pounce charge.  Centre-bottom because the player is watching the cat --
   screen centre -- while holding Space: the corners already belong to #keys
   and #look-hint, and 46px of bottom keeps it off the screen edge.  Hidden until
   a charge starts so the idle screen stays clean; the exit (260ms, falling)
   is slower than the entry (120ms) so a release reads as the pounce being
   spent rather than the meter breaking. */
#charge{left:0;right:0;margin:0 auto;bottom:46px;width:190px;padding:8px 12px 9px;
  pointer-events:none;
  z-index:4;opacity:0;visibility:hidden;transform:translateY(10px) scale(.96);
  transition:opacity .26s ease-in,transform .26s ease-in,visibility 0s .26s}
#charge.on{opacity:1;visibility:visible;transform:none;
  transition:opacity .12s ease-out,transform .12s ease-out}
#charge span{display:block;text-align:center;margin-bottom:6px;font-size:.6rem;
  letter-spacing:.19em;text-transform:uppercase;color:var(--dim)}
#charge i{display:block;height:5px;border-radius:2px;background:var(--edge);
  overflow:hidden}
/* The fill is a scaleX of --charge, which hud.js writes every charging
   frame: a transform never touches layout, where an animated width would.
   Full charge flips ink to accent -- accent is this HUD's "on" colour (the
   switcher, the keycaps) -- and throbs the bar, because "banked the full
   1.5x" has to land while the player's eyes are on the cat, not the meter. */
#charge i::before{content:"";display:block;height:100%;background:var(--ink);
  transform-origin:0 50%;transform:scaleX(var(--charge,0));transition:background .15s}
#charge.ready{border-color:var(--accent)}
#charge.ready span{color:var(--accent)}
#charge.ready i::before{background:var(--accent)}
#charge.ready i{animation:charge-pulse .55s ease-in-out infinite}
@keyframes charge-pulse{50%{transform:scale(1.04,1.4)}}
@media (prefers-reduced-motion:reduce){
  #charge{transform:none;transition:opacity .12s,visibility 0s .12s}
  #charge.on{transition:opacity .12s}
  #charge.ready i{animation:none}
}
